var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1856",
    d: "M12,15.5c0.6,0,1-0.2,1.4-0.6S14,14,14,13.5c0-0.5-0.2-1-0.6-1.4s-0.9-0.6-1.4-0.6s-1,0.2-1.4,0.6 S10,12.9,10,13.5c0,0.6,0.2,1,0.6,1.4S11.4,15.5,12,15.5z M4,21c-0.5,0-1-0.2-1.4-0.6S2,19.5,2,19V8c0-0.6,0.2-1,0.6-1.4 C3,6.2,3.5,6,4,6h4V4c0-0.5,0.2-1,0.6-1.4S9.4,2,10,2h4c0.6,0,1,0.2,1.4,0.6S16,3.4,16,4v2h4c0.6,0,1,0.2,1.4,0.6 C21.8,7,22,7.4,22,8v11c0,0.6-0.2,1-0.6,1.4S20.6,21,20,21H4z M4,19h16V8H4V19z M10,6h4V4h-4V6z M4,19V8V19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.75288edc94397e12b9ed8074b5e8f1a9.svg";
export { ForwardRef as ReactComponent };